/**
 * 接口返回的 initData 存库多为 JSON 字符串；空串或非 JSON 时避免 JSON.parse 抛错导致整屏加载失败
 */
export function parseInitDataAfterFetch (raw) {
  if (raw == null || raw === '') return []
  if (typeof raw !== 'string') return raw
  try {
    return JSON.parse(raw)
  } catch (e) {
    return []
  }
}

/**
 * 存库时对字符串多次 JSON.stringify 时，解析一次仍得到带引号的 JSON 字符串；富文本需剥到最终 HTML
 */
export function unwrapJsonStringLayers (s) {
  if (s == null || typeof s !== 'string') return s
  let out = s
  for (let i = 0; i < 8; i++) {
    const t = out.trim()
    if (t.length < 2 || t[0] !== '"' || t[t.length - 1] !== '"') break
    try {
      const next = JSON.parse(out)
      if (typeof next !== 'string') break
      out = next
    } catch {
      break
    }
  }
  return out
}

/**
 * chartData 存库时多为 JSON.stringify；富文本为 HTML 时，部分接口直接回传 HTML 字符串，无法 JSON.parse，需原样使用
 */
export function parseChartDataAfterFetch (raw, chartComponent) {
  if (raw == null) {
    return chartComponent === 'richText' ? '' : raw
  }
  if (typeof raw !== 'string') {
    return raw
  }
  if (raw.trim() === '' && chartComponent === 'richText') {
    return ''
  }
  try {
    const parsed = JSON.parse(raw)
    if (chartComponent === 'richText' && typeof parsed === 'string') {
      return unwrapJsonStringLayers(parsed)
    }
    return parsed
  } catch (e) {
    if (chartComponent === 'richText') {
      return unwrapJsonStringLayers(raw)
    }
    throw e
  }
}

export function needIndexComponent (chartComponent) {
  return !['text', 'borderBlock', 'signName', 'timeClock', 'imageBlock', 'compositeTabBar', 'compositePanelHost'].includes(chartComponent)
}

/** 指标库接口 indicatorChart 白名单：组合图与折线共用指标定义 */
export function indicatorChartTypeForApi (chartComponent) {
  if (chartComponent === 'lineBarMix') return 'line'
  return chartComponent
}
